import { isAppError, normalizeApiError } from '@/lib/errors';

const BULK_ERROR_MESSAGES: Record<string, string> = {
  BULK_IMPORT_FILE_REQUIRED: 'Selecione um arquivo para continuar.',
  BULK_IMPORT_INVALID_FILE: 'Selecione um arquivo CSV válido.',
  BULK_IMPORT_INVALID_BRANDS: 'Uma ou mais marcas selecionadas não são válidas.',
  VALIDATION_ERROR: 'Verifique os dados informados e tente novamente.',
};

function appendDetails(message: string, details: unknown): string {
  if (!details || typeof details !== 'object') {
    return message;
  }

  const values = Object.values(details as Record<string, unknown>)
    .flatMap((value) => (Array.isArray(value) ? value : [value]))
    .filter((value): value is string => typeof value === 'string' && value.trim().length > 0);

  if (values.length === 0) {
    return message;
  }

  return `${message} ${values[0]}`;
}

export function getBulkImportErrorMessage(error: unknown): string {
  const normalized = normalizeApiError(error);
  const message =
    BULK_ERROR_MESSAGES[normalized.code] ?? 'Não foi possível processar a importação.';
  return appendDetails(message, normalized.details);
}

export function getBulkConfirmErrorMessage(error: unknown): string {
  const normalized = isAppError(error) ? error : normalizeApiError(error);
  const message =
    BULK_ERROR_MESSAGES[normalized.code] ?? 'Não foi possível processar a importação.';
  return appendDetails(message, normalized.details);
}

export { BULK_ERROR_MESSAGES };
